import React from "react";

export default function FiltersCompletedSheets({ filters, setFilters, onSearch }) {
  return (
    <div className="card mb-3">
      <div className="card-body">

        <div className="row g-2 mb-2">
          <div className="col-4">
            <input
              type="text"
              className="form-control"
              placeholder="Название"
              value={filters.namePart}
              onChange={(e) => setFilters({ ...filters, namePart: e.target.value })}
            />
          </div>

          <div className="col-3">
            <input
              type="datetime-local"
              className="form-control"
              value={filters.startTime ?? ""}
              onChange={(e) =>
                setFilters({ ...filters, startTime: e.target.value || null })
              }
            />
          </div>

          <div className="col-3">
            <input
              type="datetime-local"
              className="form-control"
              value={filters.endTime ?? ""}
              onChange={(e) =>
                setFilters({ ...filters, endTime: e.target.value || null })
              }
            />
          </div>

          <div className="col-2">
            <button className="btn btn-primary w-100" onClick={onSearch}>
              Найти
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
